export default __webpack_public_path__ + "static/media/IGRS_7.df8abaac.png";